export default __webpack_public_path__ + "static/media/event.4b9df330.svg";